export const tags = [
  "jnct-mfa-form",
] as const;
